import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Screenshot = makeShortcode("Screenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`An organization administrator can delete the organization; packages in
the organization will also `}<a parentName="p" {...{
        "href": "/unpublishing-packages-from-the-registry"
      }}>{`be deleted`}</a>{` if they fulfill the
`}<a parentName="p" {...{
        "href": "/policies/unpublish"
      }}>{`requirements to unpublish packages`}</a>{`.  Packages that
cannot be deleted can be
`}<a parentName="p" {...{
        "href": "/deprecating-and-undeprecating-packages-or-package-versions"
      }}>{`deprecated`}</a>{`
instead.`}</p>
    <ol>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['account-settings'].text}</>
        <>{shared['account-settings'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the left sidebar, click the name of the organization that you want to delete.`}</p>
        <Screenshot src="/organizations/creating-and-managing-organizations/left-sidebar.png" alt="Screenshot of left sidebar" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <>{shared['organization-billing-tab'].text}</>
        <>{shared['organization-billing-tab'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Under "delete organization", click `}<strong>{`Delete`}</strong>{`.`}</p>
        <Screenshot src="/organizations/creating-and-managing-organizations/org-delete-button.png" alt="Screenshot of org delete button" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`You will be given an overview of the packages in your organization and what will happen to them when your organization is deleted.  Packages that `}<a parentName="p" {...{
            "href": "/unpublishing-packages-from-the-registry"
          }}>{`can be unpublished`}</a>{` will be deleted.`}</p>
        <p parentName="li">{`If you are sure that you want to continue, enter your organization name and click `}<strong>{`Delete this organization`}</strong>{`.`}</p>
 <Screenshot src="/organizations/creating-and-managing-organizations/org-delete-plan.png" alt="Screenshot of org delete plan" mdxType="Screenshot" />
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      